import sortBy from "lodash/sortBy";
import FieldRenderType, {
  AllowedRenderTypesWithNoValueInDisplayProfile
} from "shared/form/renderer/enums/FieldRenderType";
import { ApiFieldForProfileDisplay, OptionValueWithResource } from "shared/types/ApiFieldForProfileDisplay";
import { DISPLAY_ORDER_KEY } from "shared/utils/constants";

// this will group fields like URL with Icon to show social media fields together
// will also remove fields with null values
export function getSchemaFieldsForDisplayProfile(
  schemaList: Array<ApiFieldForProfileDisplay>
): Array<ApiFieldForProfileDisplay> {
  let arr = schemaList.filter((o: ApiFieldForProfileDisplay) => {
    if (o.renderType === FieldRenderType.CHECK_BOX) {
      if (o.imageIcon) {
        // remove checkbox type field if it has image icon in it and value is false i.e. unchecked
        return Boolean(typeof o.value === "object" && !Array.isArray(o.value) && o.value.value);
      }
    } else if (o.renderType === FieldRenderType.URL_WITH_ICON) {
      // remove individual fields that are of type URL_WITH_ICON as we would show them in a group
      return false;
    } else if (AllowedRenderTypesWithNoValueInDisplayProfile.includes(o.renderType)) {
      // allow HTML and Section_Separator fields as their value would be null;
      return true;
    } else if (typeof o.value === "object" && !Array.isArray(o.value) && o.value.value === null) {
      // if value of node is null then remove node
      return false;
    } else if (typeof o.value === "object" && Array.isArray(o.value) && !o.value.length) {
      // if value is array but length is 0 then remove node
      return false;
    } else if (
      typeof o.value === "object" &&
      !Array.isArray(o.value) &&
      Array.isArray(o.value.value) &&
      !o.value.value.length
    ) {
      // o.value is object and value key within o.value is array but length is 0
      return false;
    }
    return true;
  });

  // get url_with_icon type fields if they have value
  const urlWithIconFields = schemaList.filter(
    (o: ApiFieldForProfileDisplay) =>
      o.renderType === FieldRenderType.URL_WITH_ICON &&
      typeof o.value === "object" &&
      !Array.isArray(o.value) &&
      o.value.value !== null
  );

  // all the fields that are of type URL_WITH_ICON should be displayed in a group
  // use the display order of first field when all are sorted according to display order
  // add the grouped field in list of fields to display
  if (urlWithIconFields.length) {
    const sortedFields = sortBy(urlWithIconFields, DISPLAY_ORDER_KEY);
    const groupOptions: Array<OptionValueWithResource> = sortedFields.map((o: ApiFieldForProfileDisplay) => {
      const valueObj = o.value as OptionValueWithResource;
      return { value: valueObj.value, resource: o.imageIcon?.url as string };
    }, []);
    const groupedUrlWithIcon: ApiFieldForProfileDisplay = {
      ...sortedFields[0],
      renderType: FieldRenderType.SOCIAL_MEDIA_GROUP,
      displayLabel: "",
      fullWidthView: true,
      indented: false,
      value: groupOptions
    };
    arr.push(groupedUrlWithIcon);
  }

  return sortBy(arr, DISPLAY_ORDER_KEY);
}
